module.exports = __webpack_public_path__ + "static/media/editOutlined.37a74a02.svg";